import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthStateService } from './auth-state.service';

export const authGuard: CanActivateFn = () => {
  const authStateService = inject(AuthStateService);
  return authStateService.ensureAuthenticated();
};
